import { useEffect, useState } from 'react';
import { BUILD_ID } from 'services/request';

const STORAGE_KEY = 'last-shown-build-id';

const useUpdateAvailable = (): {
  isUpdateAvailable: boolean;
  setIsUpdateAvailable: (status: boolean) => void;
} => {
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const checkForUpdate = async (): Promise<void> => {
      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration) return;

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller &&
            BUILD_ID !== localStorage.getItem(STORAGE_KEY)
          ) {
            setIsUpdateAvailable(true);
            localStorage.setItem(STORAGE_KEY, BUILD_ID);
          }
        });
      });
    };

    checkForUpdate();

    setInterval(() => {
      navigator.serviceWorker.getRegistration().then((reg) => reg?.update());
    }, 60000);
  }, []);

  return { isUpdateAvailable, setIsUpdateAvailable };
};

export default useUpdateAvailable;
